// src/components/home/ServicesSection.tsx
import React from "react";

const ServicesSection: React.FC = () => (
  <section className="services-wrapper" id="services">
    <div className="testimonials-container">
      <div className="testimonials-header">
        <h2 className="section-title">Services</h2>
        <p className="section-subtitle">
          Specialized in designing, building, and scaling secure, low-latency
          cloud and AI-based solutions for modern teams.
        </p>
      </div>

      {/* Reuse testimonials-grid + testimonials-card for identical card styling */}
      <div className="testimonials-grid">
        {/* Cloud-Native Architecture */}
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            {/* icon can be anything – using shield/cloud-like icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 3l7 4v5c0 4.418-3.134 8-7 8s-7-3.582-7-8V7z"
              />
            </svg>
          </div>
          <h3 className="service-title">
            Cloud-Native Architecture & Modernization
          </h3>
          <p className="service-body">
            Architect resilient AWS platforms using EKS, ECS Fargate, Lambda,
            RDS, DynamoDB, SQS, and EventBridge. Transformation of legacy
            systems to scalable microservices.
          </p>
          <ul className="service-list">
            <li>Microservices &amp; event-driven design</li>
            <li>Kubernetes migration (EKS)</li>
            <li>AWS Well-Architected review</li>
            <li>Multi-environment (dev/uat/prod) blueprints</li>
          </ul>
        </div>

        {/* Generative AI Solutions */}
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="3" />
                <path d="M12 3v3m0 12v3m9-9h-3M6 12H3m15.364-6.364L16.95 7.05M7.05 16.95l-1.414 1.414M7.05 7.05L5.636 5.636m12.728 12.728L16.95 16.95" />
              </g>
            </svg>
          </div>
          <h3 className="service-title">
            Generative AI Solutions & RAG Engineering
          </h3>
          <p className="service-body">
            Develop domain-specific GenAI assistants and automation pipelines
            using LLMs, vector search, and RAG on AWS Bedrock/OpenAI.
          </p>
          <ul className="service-list">
            <li>Domain-specific chat assistants</li>
            <li>RAG pipelines over docs &amp; data</li>
            <li>AI-powered reports &amp; analytics</li>
            <li>Multi-agent orchestration</li>
          </ul>
        </div>

        {/* Full-Stack & DevOps */}
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 7h16M4 12h10M4 17h7"
              />
            </svg>
          </div>
          <h3 className="service-title">Full-Stack Engineering & DevOps</h3>
          <p className="service-body">
            Complete project delivery using Java/Spring, Node.js, React, and
            efficient CI/CD (Docker, Terraform, CDK, GitLab/GitHub Actions).
          </p>
          <ul className="service-list">
            <li>REST / GraphQL API backends</li>
            <li>React &amp; TypeScript frontends</li>
            <li>CI/CD pipelines &amp; Infrastructure as Code</li>
            <li>Performance &amp; cost optimization</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default ServicesSection;
